import { FETCH_RETAILER } from "../actions/types";

export const retailerReducer = (state = null, action) => {
  switch (action.type) {
    case FETCH_RETAILER:
      return action.payload;
    default:
      return state;
  }
};
